<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->
<header class="slds-page-header">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title">
      <div class="slds-media">
        <div class="slds-media__figure">
          <div class="slds-avatar">
            <img alt="Project Workbench" src="assets/accorto/projectWorkbench-100.svg">
          </div>
        </div>
        <div class="slds-media__body">
          <div class="slds-page-header__name">
            <div class="slds-page-header__name-title">
              <h1>
                <span i18n id="pw-hdr">Project Workbench</span>
                <span class="slds-page-header__title" id="pw-name">{{projectName}}</span>
              </h1>
            </div>
            <div class="slds-page-header__name-switcher">
              <div class="slds-dropdown-trigger slds-dropdown-trigger_click">
                <button (click)="onProjectSelectClick()"
                        aria-haspopup="true"
                        class="slds-button slds-button_icon slds-button_icon-small"
                        i18n-title
                        id="pw-select-project" title="Select Project">
                  <svg aria-hidden="true" class="slds-button__icon slds-icon_x-small">
                    <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#down"></use>
                  </svg>
                  <span class="slds-assistive-text" i18n>Select Project</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slds-page-header__col-actions">
      <div class="slds-page-header__controls">

        <div class="slds-avatar slds-m-right_small">
          <img *ngIf="busy" alt="Loading ..." id="busy" src="/assets/images/busy.svg" title="Loading ...">
        </div>
        <div class="slds-page-header__control slds-show_medium">
          <div class="slds-m-right_small slds-show_inline-block">
            <acc-help-button [title]="title ? title : ''">
            </acc-help-button>
          </div>
        </div>

        <div class="slds-page-header__control slds-show_medium">
          <div class="slds-form-element slds-m-horizontal_small">
            <label class="slds-checkbox_toggle slds-grid">
              <input (click)="onShowResourceClick($event)"
                     [checked]="showResources"
                     aria-describedby="resource-toggle"
                     id="pw-resource-toggle"
                     name="resource-toggle"
                     type="checkbox"/>
              <span aria-live="assertive" class="slds-checkbox_faux_container" id="resource-toggle">
                <span class="slds-checkbox_faux"></span>
                <span class="slds-checkbox_on" i18n>Showing Resources</span>
                <span class="slds-checkbox_off" i18n>Hiding Resources</span>
              </span>
            </label>
          </div>
        </div>

        <div class="slds-page-header__control slds-show_medium">
          <button (click)="onRefresh()"
                  class="slds-button slds-button_icon slds-button_icon-border"
                  i18n-title
                  id="pw-refresh" title="Refresh">
            <svg aria-hidden="true" class="slds-button__icon">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#refresh"></use>
            </svg>
            <span class="slds-assistive-text" i18n>Refresh</span>
          </button>
        </div>

        <div *ngIf="project"
             class="slds-page-header__control slds-show_large">
          <button (click)="onProjectLineNew()"
                  class="slds-button slds-button_neutral"
                  id="pw-new-pl"
                  title="New Project Line">
            <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#new"></use>
            </svg>
            <span i18n>New Line</span>
          </button>
        </div>

        <div class="slds-page-header__control">
          <div class="slds-button-group" role="group">
            <button (click)="onPlanCurrentClick('P')"
                    [ngClass]="showPlanCurrent === 'P' ? 'slds-button_success' : 'slds-button_neutral'"
                    class="slds-button"
                    i18n i18n-title id="pw-s-plan" title="Planned Information">Plan
            </button>
            <button (click)="onPlanCurrentClick('C')"
                    [ngClass]="showPlanCurrent === 'C' ? 'slds-button_brand' : 'slds-button_neutral'"
                    class="slds-button"
                    i18n i18n-title id="pw-s-current" title="Current Information">Current
            </button>
            <button (click)="onPlanCurrentClick('B')"
                    [ngClass]="showPlanCurrent === 'B' ? 'slds-button_destructive' : 'slds-button_neutral'"
                    class="slds-button slds-show_small"
                    i18n i18n-title id="pw-s-both" title="Current with Plan Information">Both
            </button>
          </div>
        </div>

      </div>
    </div>
  </div><!--header-row-->

  <!-- status -->
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-meta">
      <acc-status-line [error]="error" [message]="message"></acc-status-line>
    </div>
  </div>

  <div class="slds-page-header__row slds-page-header__row_gutters">
    <div class="slds-page-header__col-details">
      <ul class="slds-page-header__detail-row">
        <li class="slds-page-header__detail-block">
          <div class="slds-text-title slds-truncate"
               i18n title="Effort">Effort (Plan » Current)
          </div>
          <div [title]="projectEffortInfo"
               class="slds-truncate">
            <span>{{ projectEffortInfo }}</span>
            <div class="slds-m-top_medium">
              <button (click)="onReschedule()"
                      class="slds-button slds-button_neutral"
                      id="pw-reschedule">
                <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#macros"></use>
                </svg>
                <span i18n>Reschedule</span>
              </button>
            </div>
          </div>
        </li>
        <li class="slds-page-header__detail-block slds-show_medium">
          <div class="slds-text-title slds-truncate"
               i18n title="Effort">Plan
          </div>
          <div [title]="projectPlanInfo"
               class="slds-truncate">
            <span>{{ projectPlanInfo }}</span>
            <div *ngIf="selectedLink"
                 class="slds-m-top_medium">
              <button (click)="onLinkDelete()"
                      class="slds-button slds-button_neutral"
                      id="pw-delete-link">
                <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#delete"></use>
                </svg>
                <span i18n>Delete Link</span>
              </button>
            </div>
          </div>
        </li>
        <li class="slds-page-header__detail-block slds-show_medium">
          <div class="slds-text-title slds-truncate"
               i18n title="Effort">Current
          </div>
          <div [title]="projectCurrentInfo"
               class="slds-truncate">
            <span>{{ projectCurrentInfo }}</span>
          </div>
        </li>
        <li class="slds-page-header__detail-block slds-show_x-large">
          <div [title]="projectCountInfoAll"
               class="slds-text-title slds-truncate" i18n>Counts
          </div>
          <div [title]="projectCountInfo + ' - ' + projectCountInfoAll"
               class="slds-truncate">
            {{ projectCountInfo }}
          </div>
        </li>

        <li class="slds-page-header__detail-block" style="margin-left: auto; max-width: 55%">
          <div [formGroup]="svgForm" class="slds-select_container"
               style="display: inline-block; vertical-align: top;">
            <select (change)="onSvgZoomLevel($event)" class="slds-select" formControlName="zoomLevel"
                    i18n-title id="pw-zoom"
                    name="zoomLevel" title="Zoom Level">
              <option *ngFor="let op of svgZoomOptions"
                      [value]="op.name">{{op.label}}</option>
            </select>
          </div>

          <div class="slds-m-left_smal slds-show_inline-block">
            <button (click)="onSvgPan('U')"
                    class="slds-button slds-button_icon slds-button_icon-border-filled"
                    i18n-title id="pw-move-u" style="display: block; margin: auto"
                    title="Move Up">
              <svg aria-hidden="true" class="slds-button__icon">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#up"></use>
              </svg>
              <span class="slds-assistive-text" i18n>Move Up</span>
            </button>
            <div class="slds-button-group" style="display: block">
              <button (click)="onSvgPan('L')"
                      class="slds-button slds-button_icon slds-button_icon-border-filled"
                      i18n-title id="pw-move-l" title="Move Left">
                <svg aria-hidden="true" class="slds-button__icon">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#left"></use>
                </svg>
                <span class="slds-assistive-text" i18n>Move Left</span>
              </button>
              <button (click)="onSvgZoomFactor('I')"
                      class="slds-button slds-button_icon slds-button_icon-border-filled"
                      i18n-title id="pw-zoom-i" title="Zoom In">
                <svg aria-hidden="true" class="slds-button__icon">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#zoomin"></use>
                </svg>
                <span class="slds-assistive-text" i18n>Zoom In</span>
              </button>
              <button (click)="onSvgZoomFactor('O')"
                      class="slds-button slds-button_icon slds-button_icon-border-filled"
                      i18n-title id="pw-zoom-o" title="Zoom Out">
                <svg aria-hidden="true" class="slds-button__icon">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#zoomout"></use>
                </svg>
                <span class="slds-assistive-text" i18n>Zoom Out</span>
              </button>
              <button (click)="onSvgPan('R')"
                      class="slds-button slds-button_icon slds-button_icon-border-filled"
                      i18n-title id="pw-move-r" title="Move Right">
                <svg aria-hidden="true" class="slds-button__icon">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#right"></use>
                </svg>
                <span class="slds-assistive-text" i18n>Move Right</span>
              </button>
            </div>
            <button (click)="onSvgPan('D')"
                    class="slds-button slds-button_icon slds-button_icon-border-filled"
                    i18n-title id="pw-move-d" style="display: block; margin: auto"
                    title="Move Down">
              <svg aria-hidden="true" class="slds-button__icon">
                <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#down"></use>
              </svg>
              <span class="slds-assistive-text" i18n>Move Down</span>
            </button>
          </div>

        </li>
      </ul>
    </div>
  </div>

</header>


<psa-workbench (linkClicked)="onLinkClick($event)"
               (projectLineClicked)="onProjectLineClick($event)"
               [layout]="layout"
               [version]="version"
               [wb]="wb">
</psa-workbench>

<!-- Reschedule -->
<acc-modal-float (closing)="onRescheduleClose()"
                 *ngIf="showProjectReschedule"
                 [showClear]="false"
                 iconRef="/assets/icons/utility-sprite/svg/symbols.svg#macros"
                 title="Project Reschedule"
                 width="36rem">
  <psa-project-reschedule [wb]="wb"></psa-project-reschedule>
</acc-modal-float>

<!-- Project Selection -->
<acc-modal-float (closing)="onProjectSelected($event === true ? undefined : null)"
                 *ngIf="showProjectSelect"
                 i18n-title title="Select Project">
  <acc-data-record-selector (recordSelected)="onProjectSelected($event)"
                            [columnNames]="projectSelectColumns"
                            [records]="projectRecords">
  </acc-data-record-selector>
</acc-modal-float>

<psa-project-line-editor (editorClosed)="onProjectLineEditComplete()"
                         *ngIf="showProjectLineEditor && projectLine"
                         [initialTab]="projectLineTab"
                         [recordI]="projectLine">
</psa-project-line-editor>


<footer *ngIf="isDebug()">
  <hr/>
  <dl>
    <dt><b>Pallet Layout</b></dt>
    <dd>
      pageWidth={{layout.pageWidth}}
      svg w={{layout.svgWidth}} h={{layout.svgHeight}} viewBox={{layout.svgViewBox}}
      {{layout.svgTransform}} zoomLevel={{layout.zoomLevel}} xDayFactor={{layout.xDayFactor}}
      durationDays={{layout.durationDays}}
      <!--
      <pre>{{ layout | json }}</pre>
      -->
    </dd>

    <div *ngFor="let p of wb.pallets">
      <div><b>Pallet {{p.name}}</b></div>
      <div *ngFor="let c of p.crates">
        <div><b>Crate: {{c.name + ' id=' + c.id}}</b></div>
        <div *ngFor="let cc of c.cartons">
          <div><b>- Carton: {{cc.name + ' id=' + cc.id}}</b></div>
          {{ cc | json }}
        </div>
      </div>
    </div>
  </dl>
</footer>
